module.exports = __webpack_public_path__ + "img/u2_zijingM416.fdc312dc.jpg";